import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const ApplicationsCTA = () => {
  const navigate = useNavigate();

  return (
    <section data-testid="applications-cta-section" className="bg-baseLight px-6 pt-[30px] pb-[30px] sm:pt-[32px] sm:pb-[32px] lg:px-12 lg:pt-[48px] lg:pb-[88px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.55 }}
        data-testid="applications-cta-panel"
        className="mx-auto max-w-[1280px] rounded-3xl bg-glacier px-6 py-14 text-center sm:px-10 sm:py-16 lg:px-16 lg:py-20"
      >
        <h2
          data-testid="applications-cta-headline"
          className="mx-auto max-w-xl font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:max-w-none lg:whitespace-nowrap lg:text-[41px]"
        >
          Which application fits your operation
        </h2>
        <p data-testid="applications-cta-text" className="mx-auto mt-[32px] lg:mt-5 max-w-lg text-[15px] leading-relaxed text-inkSoft">
          Every project starts with the site itself — its loads, energy use, diesel
          consumption, outage exposure and backup requirements.
        </p>
        <div className="text-left lg:text-center">
          <button
            type="button"
            data-testid="applications-cta-button"
            onClick={() => navigate("/#contact")}
            className="mt-8 inline-flex h-11 items-center gap-2 bg-teal text-white text-sm font-medium rounded-full px-7 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5"
          >
            Request a Farm Energy Assessment
          </button>
        </div>
      </motion.div>
    </section>
  );
};
